import * as React from 'react';
import { Icon } from '@blueprintjs/core';

interface Props {
    giant?: boolean;
};

interface State {};


export class NotDoneMarker extends React.Component<Props, State> {

    state: State = {}

    render() {
        const {
            giant
        } = this.props;

        if (giant === true) {
            return <Icon iconSize={30} icon={"circle"} style={{color: '#bf7326'}} />
        }

        return <Icon icon={"circle"} style={{color: '#bf7326'}} />
    }
}
